import type { ContentBankListItem } from '@/types/apis/ContentBank';
import type { IErrorResponse } from '@/types/apis/Error';
import type { PaginationResponse } from '@/types/PaginationResponse';

import {
  useInfiniteQuery,
  type UseInfiniteQueryResult,
} from '@tanstack/react-query';
import queryString from 'query-string';

import url from '@/statics/urls';
import api from '@/utils/api';
import {
  getNextPageParam,
  getPreviousPageParam,
} from '@/utils/infinitePaginationParams';

const useContentBank = ({
  queries,
  enabled,
}: {
  queries: { category_id?: string; search_tags?: string; search?: string };
  enabled?: boolean;
}): UseInfiniteQueryResult<
  {
    pageParams: { pageParams: { current: number } }[];
    pages: PaginationResponse<ContentBankListItem>[];
  },
  IErrorResponse
> => {
  return useInfiniteQuery({
    queryKey: [`${url.contentBank}?${queryString.stringify(queries)}`],
    queryFn: ({ pageParam }) => {
      return api.get(
        `${url.contentBank}?${queryString.stringify({
          current: pageParam.current as number,
          pageSize: 10,
          ...queries,
        })}`
      );
    },
    getNextPageParam,
    getPreviousPageParam,
    initialPageParam: { pageParam: { current: 1 } },
    enabled,
  });
};

export default useContentBank;
